
import Vue from  'vue';

export default {

    methods: {

        onClick()
        {
            if (this.$root.$children[0].componentId == 'page-home')
            {
                this.$root.$children[0].scrollTo(0, 0)
            }
            else
            {
                this.$root.$children[0].loadPage('/home')
            }
        }
    }
}
